import { Toolbar } from "ngx-editor";

export const FILE_EXTENSION: string = 'png';
export const FILE_NAME_PREFIX: string = 'allianz-TA_';

export const EDITOR_CONFIG: Toolbar = [
  ['bold', 'italic'],
  ['underline', 'strike'],
  ['code', 'blockquote'],
  ['ordered_list', 'bullet_list'],
  [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
  ['link'],
  ['text_color', 'background_color'],
  ['align_left', 'align_center', 'align_right', 'align_justify'],
];

export const ACCEPTED_FILES_TYPE: string[] = [
  'image/jpeg',
  'image/png',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/zip',
  'application/x-zip-compressed',
  'application/x-rar-compressed',
  'text/plain',
  'application/pdf'
];

export const CAPTURE_SCREEN_CONFIG: any = {
  scale: 1.75,
  windowWidth: 1050,
  useCORS: true,
  logging: false
};
